import React from 'react';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  button: {
    fontSize: 14,
    fontWeight: 400,
    color: '#2962FF',
    marginRight: '16px',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  paper: {
    backgroundColor: 'white',
    border: '1px solid #E0E0E0',
    padding: '16px',
    minWidth: 400,
    maxWidth: 800,
    '& > div': {
      maxHeight: 200,
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        width: '8px',
        height: '8px'
      },
      /* Track */
      '&::-webkit-scrollbar-track': {
        background: '#ebebeb',
        borderRadius: '10px',
        margin: '2px'
      },
      /* Handle */
      '&::-webkit-scrollbar-thumb': {
        background: '#9E9E9E',
        borderRadius: '10px'
      },
      /* Handle on hover */
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#7b7a7a'
      }
    }
  }
}));

export default function GridPopover(props) {
  const { classes: classesOverride, multiple = true, id } = props;
  const classes = useStyles({ classes: classesOverride });
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <React.Fragment>
      {multiple ? (
        <Button onClick={handleClick} className={classes.button} id={id}>
          {props.text}
        </Button>
      ) : (
        <span>{props.text}</span>
      )}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        classes={{ paper: classes.paper }}
      >
        {props.popoverContent}
      </Popover>
    </React.Fragment>
  );
}
